import { r as registerInstance } from './index-BntG-4Sv.js';
import { EventEmitter, ServiceProvider, ConfigurationContextService, LicenseContextService, ProductInfoContextService, RepositoryService, RepositoryContextService, mapAuthenticatedUserResponseToModel, SecurityContextService, AuthenticationStorageService, AuthenticationService, LanguageContextService, EventService, NavigationEnd, RepositoryLocationContextService, ConfirmCancelPayload, CONFIRM_CANCEL_EVENT, ToastMessage, CREATE_TOAST_EVENT, service, OntoToastrService, notify, AutocompleteContextService, NamespacesContextService, NamespaceMap, AuthorizationService, AuthStrategyResolver, SecurityConfig } from '@ontotext/workbench-api';

const common$1 = {
	"import": "Import",
	button: {
		ok: "OK",
		close: "Close",
		cancel: "Cancel"
	},
	loading: "Loading..."
};
const language_selector$1 = {
	toggle_menu: {
		label: "Select language",
		tooltip: "Current language: English"
	},
	language: {
		en: {
			label: "en &middot; English",
			tooltip: {
				selected: "Current language",
				not_selected: "Change language to English"
			}
		},
		fr: {
			label: "fr &middot; Français",
			tooltip: {
				selected: "Current language",
				not_selected: "Changer la langue en Français"
			}
		}
	}
};
const license_alert$1 = {
	label: "No valid license",
	no_license_set: "No license was set."
};
const footer$1 = {
	label: {
		all_rights_reserved: "All rights reserved."
	}
};
const permission_banner$1 = {
	no_access_error: "You have no permission to access this functionality with your current credentials.",
	change_menu_or_user_warning: "Please choose another menu item or login as a different user."
};
const cookie$1 = {
	cookie_consent: "We may use cookies to help us improve GraphDB and develop better features. No personal or sensitive information is collected. By clicking “OK” you consent to our ",
	cookie_policy_url_label: "Cookie Policy",
	policy: {
		title: "Cookies Policy",
		purpose_heading: "Purpose",
		purpose_text: "This Cookies Policy explains the data Ontotext collects and uses when you use our GraphDB product, specifically the Free Edition.",
		purpose_enterprise_text: "Note that if you upgrade to the commercial GraphDB Enterprise Edition, no cookies will be stored on your device, regardless of settings.",
		privacy_commitment_heading: "Ontotext privacy commitment",
		privacy_commitment_text: "We are committed to not collecting any personal data or information when you use GraphDB Free. Additionally:",
		privacy_commitment_1: "We will not sell or rent the technical information we collect to others.",
		privacy_commitment_2: "We strive to maximize the protection of all technical data collected.",
		cookies_heading: "Cookies",
		cookies_text: "When you use GraphDB Free Edition, Ontotext will store cookies on your device to collect anonymous information about how you interact with the product. This technical data helps us improve and refine our software. Importantly, we cannot link this information to you personally or to any identifiable data. These cookies are solely intended to help us understand user interactions and identify potential issues within GraphDB.",
		manage_cookies_heading: "Manage cookies",
		statistic_cookies: "GraphDB analytics cookies",
		statistic_tooltip: "Toggle GraphDB analytics cookies",
		statistic_text: "These cookies help us understand how users interact with different aspects of GraphDB by collecting and reporting information anonymously. This data allows us to improve the overall product experience and develop features based on how GraphDB is used, without collecting any personal information.",
		third_party_cookies: "Third-party cookies",
		third_party_tooltip: "Toggle Third-party cookies",
		third_party_cookies_text: "We use Google Analytics 4 (GA4) cookies to help us recognize unique users and sessions, track interactions, and collect data such as page views, session duration, and engagement. These cookies are managed by Google, meaning we do not control their operation. IP anonymization is enabled by default in GA4, so it cannot store IP addresses or track users personally. No data is shared between GA4 and other Google products, and processing occurs globally, primarily in the USA, without breaching GDPR, as no personal data is collected.",
		change_cookies: "You can change your cookie preferences at any time in",
		change_cookies_location4: "Cookie policy"
	}
};
const security$1 = {
	user: {
		settings: "User settings"
	}
};
const operations_notification$1 = {
	links: {
		queries: "Running queries",
		updates: "Running updates",
		imports: "Running imports",
		CREATE_BACKUP_IN_PROGRESS: "Creating backup",
		RESTORE_BACKUP_IN_PROGRESS: "Restoring backup",
		CREATE_CLOUD_BACKUP_IN_PROGRESS: "Creating cloud backup",
		RESTORE_CLOUD_BACKUP_IN_PROGRESS: "Restoring cloud backup",
		IN_SYNC: "In sync",
		RECOVERING: "Recovering",
		OUT_OF_SYNC: "Out of sync",
		UNAVAILABLE_NODES: "Unavailable nodes"
	}
};
const user_menu$1 = {
	my_settings: "My settings",
	logout: "Logout",
	login: "Login"
};
const rdf_search$1 = {
	labels: {
		search: "Search RDF resources",
		hint: "Hint: \"abC\" matches \"abC*\", \"ab c*\" and \"ab-c*\""
	},
	buttons: {
		table: "Table",
		visual: "Visual"
	},
	tooltips: {
		close_search_area: "Close search",
		clear: "Clear"
	},
	toasts: {
		use_view_resource: "<b>Search RDF resources</b></br>Use <b>View resource</b> on this page",
		autocomplete_is_off: "Autocomplete is OFF<br>Go to Setup -> Autocomplete",
		empty_input: "Please fill the input field!",
		invalid_uri: "Invalid IRI"
	}
};
const guides$1 = {
	"confirm-cancel-modal": {
		title: "Exit the guide?",
		subtitle: "Are you sure you want to exit the guide?<br><br>You can start it anytime from <b>Help > Interactive Guides</b>",
		"exit-button": "Exit",
		"dont-show-again": "Don't start automatically"
	}
};
const openid$1 = {
	errors: {
		title: "OpenID Authentication Failed",
		unknown_flow: "Unknown auth flow: {{authFlow}}",
		invalid_pkce_state: "Invalid PKCE state",
		cannot_retrieve_token: "Cannot retrieve token after login: {{error}}",
		cannot_refresh_token: "Could not refresh OpenID token: {{error}}",
		user_no_access: "User has no access to GraphDB"
	}
};
const graph_explore_split_button$1 = {
	buttons: {
		explore_visual_graph: {
			tooltip: "Use default config"
		},
		explore_visual_graph_dropdown: {
			tooltip: "Select config"
		}
	},
	messages: {
		missing_graph_configuration: "No advanced graph configuration.",
		create_graph_configuration: "Create one",
		create_graph_configuration_link: "here"
	}
};
var en = {
	"menu.logo.link.title": "GraphDB logo",
	"menu.buttons.expand": "Expand menu",
	"menu.buttons.collapse": "Collapse menu",
	common: common$1,
	"menu.rdf.label": "RDF",
	"menu.explore.label": "Explore",
	"menu.graphs.overview.label": "Graphs overview",
	"menu.class.relationships.label": "Class relationships",
	"menu.class.hierarchy.label": "Class hierarchy",
	"menu.similarity.label": "Similarity",
	"menu.sparql.label": "SPARQL",
	"menu.monitor.label": "Monitor",
	"menu.queries.and.updates.label": "Queries and Updates",
	"menu.backup_and_restore.label": "Backup and Restore",
	"menu.enableFtsIndex.label": "Enable full-text search (FTS) index",
	"menu.ftsIndexes.label": "FTS indexes to build (comma delimited)",
	"menu.ftsStringLiteralsIndex.label": "FTS index for xsd:string literals",
	"menu.ftsIrisIndex.label": "FTS index for full-text indexing of IRIs",
	"menu.ftsDefaultAnalyzer.label": "Analyzer for the default index",
	"menu.resources.label": "System",
	"menu.setup.label": "Setup",
	"menu.lab.label": "Lab",
	"menu.ttyg.label": "Talk to Your Graph",
	"menu.repositories.label": "Repositories",
	"menu.aclmanagement.label": "ACL Management",
	"menu.users.and.access.label": "Users and Access",
	"menu.my.settings.label": "My Settings",
	"menu.cluster.label": "Cluster",
	"menu.connectors.label": "Connectors",
	"menu.namespaces.label": "Namespaces",
	"menu.autocomplete.label": "Autocomplete",
	"menu.jdbc.label": "JDBC",
	"menu.sparql.template.label": "SPARQL Templates",
	"menu.license.label": "License",
	"menu.help.label": "Help",
	"menu.system.information.label": "System information",
	"menu.rest.api.label": "REST API",
	"menu.documentation.label": "Documentation",
	"menu.tutorials.label": "Tutorials",
	"menu.support.label": "Support",
	"menu.guides.label": "Interactive guides",
	"menu.plugins.label": "Plugins",
	"menu.graphql.label": "GraphQL",
	"menu.graphql-endpoint-management.label": "Endpoint Management",
	"menu.graphql-playground.label": "GraphQL Playground",
	"visual.graph.label": "Visual graph",
	"view.rdf.rank.title": "RDF Rank",
	language_selector: language_selector$1,
	"repository-selector": {
	btn: {
		toggle: "Choose repository",
		no_repositories: "No accessible repositories"
	},
	tooltip: {
		repository: "Repository",
		location: "Location",
		local: "Local",
		type: "Type",
		types: {
			graphdb: "Graphdb",
			system: "System",
			ontop: "Ontop",
			fedx: "FedX",
			unknown: "Unknown"
		},
		permission: "Permission",
		permissions: {
			none: "None",
			read: "Read",
			write: "Read/Write",
			manage: "Read/Write/Manage",
			graphql_read: "Read (GraphQL only)",
			graphql_write: "Read/Write (GraphQL only)"
		},
		"repository-size": {
			total: "Total statements",
			explicit: "Explicit",
			inferred: "Inferred",
			expansion_ratio: "Expansion ratio (total/explicit)"
		}
	}
},
	license_alert: license_alert$1,
	footer: footer$1,
	permission_banner: permission_banner$1,
	cookie: cookie$1,
	security: security$1,
	operations_notification: operations_notification$1,
	user_menu: user_menu$1,
	rdf_search: rdf_search$1,
	guides: guides$1,
	openid: openid$1,
	graph_explore_split_button: graph_explore_split_button$1,
	"deprecation-banner": {
	solr: {
		content: "The Solr connector is deprecated and will be removed in GraphDB 12. If you use it, <b>contact us</b> through the available support channels."
	}
}
};

const common = {
	"import": "Importer",
	button: {
		ok: "D'accord",
		close: "Fermer",
		cancel: "Annuler"
	},
	loading: "Chargement..."
};
const language_selector = {
	toggle_menu: {
		label: "Sélectionner la langue",
		tooltip: "Langue actuelle : Français"
	},
	language: {
		en: {
			label: "en &middot; Anglais",
			tooltip: {
				selected: "Langue actuelle",
				not_selected: "Changer la langue en Anglais"
			}
		},
		fr: {
			label: "fr &middot; Français",
			tooltip: {
				selected: "Langue actuelle",
				not_selected: "Changer la langue en Français"
			}
		}
	}
};
const license_alert = {
	label: "Aucune licence valide",
	no_license_set: "Aucune licence n'a été définie."
};
const footer = {
	label: {
		all_rights_reserved: "Tous droits réservés."
	}
};
const permission_banner = {
	no_access_error: "Vous n'avez pas la permission d'accéder à cette fonctionnalité avec vos informations d'identification actuelles.",
	change_menu_or_user_warning: "Veuillez choisir un autre élément du menu ou vous connecter comme un autre utilisateur."
};
const cookie = {
	cookie_consent: "Nous pouvons utiliser des cookies pour nous aider à améliorer GraphDB et développer de meilleures fonctionnalités. Aucune information personnelle ou sensible n'est collectée. En cliquant sur « D'accord », vous consentez à notre ",
	cookie_policy_url_label: "politique de cookies",
	policy: {
		title: "Politique de cookies",
		purpose_heading: "Objectif",
		purpose_text: "Cette politique de cookies explique les données qu'Ontotext collecte et utilise lorsque vous utilisez notre produit GraphDB, en particulier l'édition Free.",
		purpose_enterprise_text: "Veuillez noter que si vous passez à l'édition commerciale GraphDB Enterprise, aucun cookie ne sera stocké sur votre appareil, quel que soit le paramètre.",
		privacy_commitment_heading: "Engagement de confidentialité d'Ontotext",
		privacy_commitment_text: "Nous nous engageons à ne collecter aucune donnée personnelle ou information lorsque vous utilisez GraphDB Free. De plus :",
		privacy_commitment_1: "Nous ne vendrons ni ne louerons à d'autres les informations techniques que nous collectons.",
		privacy_commitment_2: "Nous nous efforçons de maximiser la protection de toutes les données techniques collectées.",
		cookies_heading: "Cookies",
		cookies_text: "Lorsque vous utilisez l'édition GraphDB Free, Ontotext stockera des cookies sur votre appareil pour collecter des informations anonymes sur la façon dont vous interagissez avec le produit. Ces données techniques nous aident à améliorer et affiner notre produit. Il est important de noter que nous ne pouvons pas relier ces informations à vous personnellement ni à aucune donnée identifiable. Ces cookies ont uniquement pour but de nous aider à comprendre les interactions des utilisateurs et à identifier les éventuels problèmes dans GraphDB.",
		manage_cookies_heading: "Gérer les cookies",
		statistic_cookies: "Cookies d'analyse GraphDB",
		statistic_tooltip: "Activer/désactiver les cookies d'analyse GraphDB",
		statistic_text: "Ces cookies nous aident à comprendre comment les utilisateurs interagissent avec différents aspects de GraphDB en collectant et en rapportant des informations de manière anonyme. Ces données nous permettent d'améliorer l'expérience globale du produit et de développer des fonctionnalités en fonction de l'utilisation de GraphDB, sans collecter d'informations personnelles.",
		third_party_cookies: "Cookies tiers",
		third_party_tooltip: "Activer/désactiver les cookies tiers",
		third_party_cookies_text: "Nous utilisons les cookies Google Analytics 4 (GA4) pour nous aider à reconnaître les utilisateurs et sessions uniques, à suivre les interactions et à collecter des données telles que les pages consultées, la durée des sessions et l'engagement. Ces cookies sont gérés par Google, ce qui signifie que nous n'avons pas de contrôle sur leur fonctionnement. L'anonymisation IP est activée par défaut dans GA4, de sorte qu'il ne peut ni stocker les adresses IP ni suivre les utilisateurs personnellement. Aucune donnée n'est partagée entre GA4 et d'autres produits Google, et le traitement s'effectue à l'échelle mondiale, principalement aux États-Unis, sans enfreindre le RGPD, car aucune donnée personnelle n'est collectée.",
		change_cookies: "Vous pouvez modifier vos préférences de cookies à tout moment dans",
		change_cookies_location4: "Politique de cookies"
	}
};
const security = {
	user: {
		settings: "Paramètres de l'utilisateur"
	}
};
const operations_notification = {
	links: {
		queries: "Exécution de requêtes",
		updates: "Exécution de mises à jour",
		imports: "Exécution d'importations",
		CREATE_BACKUP_IN_PROGRESS: "Création de sauvegarde en cours",
		RESTORE_BACKUP_IN_PROGRESS: "Restauration de sauvegarde en cours",
		CREATE_CLOUD_BACKUP_IN_PROGRESS: "Création de sauvegarde cloud en cours",
		RESTORE_CLOUD_BACKUP_IN_PROGRESS: "Restauration de sauvegarde cloud en cours",
		IN_SYNC: "Synchronisé",
		RECOVERING: "Récupération en cours",
		OUT_OF_SYNC: "Désynchronisé",
		UNAVAILABLE_NODES: "Nœuds indisponibles"
	}
};
const user_menu = {
	my_settings: "Mes paramètres",
	logout: "Déconnexion",
	login: "Se connecter"
};
const rdf_search = {
	labels: {
		search: "Rechercher des ressources RDF",
		hint: "Indice : \"abC\" correspond à \"abC*\", \"ab c*\" et \"ab-c*\"."
	},
	buttons: {
		table: "Tableau",
		visual: "Visuel"
	},
	tooltips: {
		close_search_area: "Fermer la recherche",
		clear: "Clair"
	},
	toasts: {
		use_view_resource: "<b>Rechercher des ressources RDF</b></br>Utilisez <b>Voir la ressource</b> sur cette page",
		autocomplete_is_off: "L'autocomplétion est désactivée<br>Aller à Configuration -> Autocomplétion",
		empty_input: "S'il vous plaît remplir le champ de saisie!",
		invalid_uri: "IRI non valide"
	}
};
const guides = {
	"confirm-cancel-modal": {
		title: "Quitter le guide?",
		subtitle: "Êtes-vous sûr de vouloir quitter le guide ?<br><br>Vous pouvez le lancer à tout moment à partir de <b>Aide > Guides interactifs</b>.",
		"exit-button": "Sortie",
		"dont-show-again": "Ne pas démarrer automatiquement"
	}
};
const openid = {
	errors: {
		title: "Échec de l'authentification OpenID",
		unknown_flow: "Flux d'authentification inconnu: {{authFlow}}",
		invalid_pkce_state: "État PKCE invalide",
		cannot_retrieve_token: "Impossible de récupérer le jeton après la connexion: {{error}}",
		cannot_refresh_token: "Impossible de rafraîchir le jeton OpenID: {{error}}",
		user_no_access: "L'utilisateur n'a pas accès à GraphDB"
	}
};
const graph_explore_split_button = {
	buttons: {
		explore_visual_graph: {
			tooltip: "Utiliser la configuration par défaut"
		},
		explore_visual_graph_dropdown: {
			tooltip: "Sélectionner la configuration"
		}
	},
	messages: {
		missing_graph_configuration: "Aucune configuration avancée du graphe.",
		create_graph_configuration: "En créer une",
		create_graph_configuration_link: "ici"
	}
};
var fr = {
	"menu.logo.link.title": "Logo GraphDB",
	"menu.buttons.expand": "Développer le menu",
	"menu.buttons.collapse": "Réduire le menu",
	common: common,
	"menu.rdf.label": "RDF",
	"menu.explore.label": "Explorez",
	"menu.graphs.overview.label": "Aperçu des graphes",
	"menu.class.relationships.label": "Relations entre les classes",
	"menu.class.hierarchy.label": "Hiérarchie des classes",
	"menu.similarity.label": "Similarité",
	"menu.sparql.label": "SPARQL",
	"menu.monitor.label": "Surveiller",
	"menu.queries.and.updates.label": "Requêtes et mises à jour",
	"menu.backup_and_restore.label": "Sauvegarde et Restauration",
	"menu.enableFtsIndex.label": "Activer l'index de recherche plein texte",
	"menu.ftsIndexes.label": "Index de recherche en texte intégral à construire (délimités par des virgules)",
	"menu.ftsStringLiteralsIndex.label": "Index de recherche en texte intégral pour les littéraux xsd:string",
	"menu.ftsIrisIndex.label": "Index de recherche en texte intégral pour l'indexation en texte intégral des IRI",
	"menu.ftsDefaultAnalyzer.label": "Analyseur pour l'index par défaut",
	"menu.resources.label": "Système",
	"menu.setup.label": "Configurer",
	"menu.lab.label": "Laboratoire",
	"menu.ttyg.label": "Parlez à votre graphe",
	"menu.repositories.label": "Dépôts",
	"menu.aclmanagement.label": "Gestion ACL",
	"menu.users.and.access.label": "Utilisateurs et accès",
	"menu.my.settings.label": "Mes paramètres",
	"menu.cluster.label": "Cluster",
	"menu.connectors.label": "Connecteurs",
	"menu.namespaces.label": "Espaces de noms",
	"menu.autocomplete.label": "Autocomplétion",
	"menu.jdbc.label": "JDBC",
	"menu.sparql.template.label": "Modèles SPARQL",
	"menu.license.label": "Licence",
	"menu.help.label": "Aide",
	"menu.system.information.label": "Informations sur le système",
	"menu.rest.api.label": "API REST",
	"menu.documentation.label": "Documentation",
	"menu.tutorials.label": "Tutoriels",
	"menu.support.label": "Support",
	"menu.guides.label": "Guides interactifs",
	"menu.plugins.label": "Plugins",
	"menu.graphql.label": "GraphQL",
	"menu.graphql-endpoint-management.label": "Gestion des points de terminaison",
	"menu.graphql-playground.label": "GraphQL Playground",
	"visual.graph.label": "Graphique visuel",
	"view.rdf.rank.title": "Rang RDF",
	language_selector: language_selector,
	"repository-selector": {
	btn: {
		toggle: "Choisissez le dépôt",
		no_repositories: "Aucun dépôt accessible"
	},
	tooltip: {
		repository: "Dépôt",
		location: "L'emplacement",
		local: "Local",
		type: "Type",
		types: {
			graphdb: "Graphdb",
			system: "Système",
			ontop: "Ontop",
			fedx: "FedX",
			unknown: "Inconnu"
		},
		permission: "Permission",
		permissions: {
			none: "Aucune",
			read: "Lecture",
			write: "Lecture/Écriture",
			manage: "Lecture/Écriture/Gestion",
			graphql_read: "Lecture (GraphQL uniquement)",
			graphql_write: "Lecture/Écriture (GraphQL uniquement)"
		},
		"repository-size": {
			total: "Total des déclarations",
			explicit: "Explicite",
			inferred: "Déduit",
			expansion_ratio: "Taux d'expansion (total/explicite)"
		}
	}
},
	license_alert: license_alert,
	footer: footer,
	permission_banner: permission_banner,
	cookie: cookie,
	security: security,
	operations_notification: operations_notification,
	user_menu: user_menu,
	rdf_search: rdf_search,
	guides: guides,
	openid: openid,
	graph_explore_split_button: graph_explore_split_button,
	"deprecation-banner": {
	solr: {
		content: "Le connecteur Solr est obsolète et sera supprimé dans GraphDB 12. Si vous l'utilisez, <b>contactez-nous</b> via les canaux d'assistance disponibles."
	}
}
};

const OntoTestContext = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.bundles = { en, fr };
        this.eventEmitter = new EventEmitter();
        this.onLanguageChanged();
        this.setSecurityConfig({ enabled: false, freeAccess: { enabled: false } });
    }
    /**
     * Initializes the application configuration context.
     *
     * This method uses the ConfigurationContextService to update the application
     * configuration and returns a resolved Promise once the operation is complete.
     * @param configuration - The new Configuration object to be set.
     * @returns A Promise that resolves when the configuration update is complete.
     */
    initConfigurationContext(configuration) {
        ServiceProvider.get(ConfigurationContextService).updateApplicationConfiguration(configuration);
        return Promise.resolve();
    }
    /**
     * Updates the license information in the context.
     *
     * This method uses the LicenseContextService to update the license
     * and returns a resolved Promise once the operation is complete.
     *
     * @param license - The new License object to be set.
     * @returns A Promise that resolves when the license update is complete.
     */
    updateLicense(license) {
        ServiceProvider.get(LicenseContextService).updateGraphdbLicense(license);
        return Promise.resolve();
    }
    /**
     * Updates the product information in the context.
     *
     * This method uses the ProductInfoContextService to update the product information
     * and returns a resolved Promise once the operation is complete.
     *
     * @param productInfo - The new ProductInfo object to be set.
     * @returns A Promise that resolves when the product information update is complete.
     */
    updateProductInfo(productInfo) {
        ServiceProvider.get(ProductInfoContextService).updateProductInfo(productInfo);
        return Promise.resolve();
    }
    /**
     * Loads the repositories in the application.
     */
    loadRepositories() {
        ServiceProvider.get(RepositoryService).getRepositories().then((repositories) => {
            ServiceProvider.get(RepositoryContextService).updateRepositoryList(repositories);
        });
        return Promise.resolve();
    }
    /**
     * Sets the authenticated user in the application context.
     *
     * @param user - The AuthenticatedUser object containing the user's authentication information.
     * @returns A Promise that resolves when the authenticated user has been successfully updated
     */
    setAuthenticatedUser(user) {
        // Don't map if undefined is passed. This allows to clear the user in context
        const userModel = user
            ? mapAuthenticatedUserResponseToModel(user)
            : undefined;
        ServiceProvider.get(SecurityContextService).updateAuthenticatedUser(userModel);
        ServiceProvider.get(AuthenticationStorageService).setAuthToken('token');
        return Promise.resolve();
    }
    /**
     * Sets the security configuration in the application context.
     *
     * @param securityConfig - The SecurityConfig object containing the new security settings to be applied.
     * @returns A Promise that resolves when the security configuration has been successfully updated.
     */
    setSecurityConfig(securityConfig) {
        const config = this.createSecurityConfig(securityConfig);
        ServiceProvider.get(SecurityContextService).updateSecurityConfig(config);
        this.setAuthStrategy(config);
        return Promise.resolve();
    }
    /**
     * Logs in a user with the provided username and password.
     *
     * This method uses the AuthenticationService to perform the login operation.
     * It returns a Promise that resolves when the login process is complete.
     * @param username
     * @param password
     */
    login(username, password) {
        const authService = ServiceProvider.get(AuthenticationService);
        return authService.login({ username, password });
    }
    /**
     * Changes the application's language by updating the language bundle.
     *
     * This method uses the LanguageContextService to update the language bundle
     * based on the provided language code. It retrieves the corresponding bundle
     * from the predefined bundles object and updates the context.
     *
     * @param language - The language code (e.g., 'en' for English, 'fr' for French)
     *                   representing the desired language to switch to.
     * @returns A Promise that resolves when the language update is complete.
     */
    changeLanguage(language) {
        ServiceProvider.get(LanguageContextService).updateLanguageBundle(this.bundles[language]);
        return Promise.resolve();
    }
    /**
     * Emits {@see NavigationEnd} event with <code>oldUrl</code> and <code>newUrl</code>.
     * @param oldUrl - the value will be used as old url in the event payload.
     * @param newUrl - the value will be used as new url in the event payload.
     */
    emitNavigateEndEvent(oldUrl, newUrl) {
        ServiceProvider.get(EventService).emit(new NavigationEnd(oldUrl, newUrl));
        return Promise.resolve();
    }
    /**
     * Updates the selected repository in the application context.
     *
     * @method updateSelectedRepository
     * @param repositoryReference - The RepositoryReference object representing the repository to select.
     * @returns A Promise that resolves when the selected repository has been updated.
     */
    updateSelectedRepository(repositoryReference) {
        ServiceProvider.get(RepositoryContextService).updateSelectedRepository(repositoryReference);
        return Promise.resolve();
    }
    /**
     * Updates whether the active repository request is in a loading state.
     *
     * @param isLoading - A boolean value indicating whether the repository location is in a loading state.
     *                    True indicates request is in progress, false indicates loading is complete.
     * @returns A Promise that resolves when the loading state update is complete.
     */
    updateIsLoadingActiveRepositoryLocation(isLoading) {
        ServiceProvider.get(RepositoryLocationContextService).updateIsLoading(isLoading);
        return Promise.resolve();
    }
    /**
     * Opens the confirm cancel dialog.
     *
     * @param hasDontShowAgain - Whether to show the "Don't show again" button in the dialog.
     */
    openConfirmCancel(hasDontShowAgain) {
        this.eventEmitter.emit({ NAME: CONFIRM_CANCEL_EVENT, payload: new ConfirmCancelPayload(hasDontShowAgain, (action) => {
                console.info('Dialog closed with action:', action);
            }) });
        return Promise.resolve();
    }
    /**
     * Opens a toast
     *
     * @param toast the toast to open
     */
    addToastr(toast) {
        this.eventEmitter.emit({ NAME: CREATE_TOAST_EVENT, payload: new ToastMessage(toast.type, toast.message) });
        return Promise.resolve();
    }
    /**
     * Adds a notification to the application.
     * @param notification - The Notification object containing the notification details.
     */
    addNotification(notification) {
        // create the toastr service, which starts listening for notifications
        service(OntoToastrService);
        notify(notification);
        return Promise.resolve();
    }
    /**
     * Sets the autocomplete status in the context.
     *
     * @param enabled whether autocomplete is enabled or disabled.
     */
    setAutocomplete(enabled) {
        ServiceProvider.get(AutocompleteContextService).updateAutocompleteEnabled(enabled);
        return Promise.resolve();
    }
    /**
     * Sets the namespace map in the application context.
     *
     * @param rawNamespaces - The namespace map containing prefix-to-URI mappings to be used throughout the application
     * @returns A Promise that resolves when the namespace map has been successfully updated
     */
    updateNamespaces(rawNamespaces) {
        ServiceProvider.get(NamespacesContextService).updateNamespaces(new NamespaceMap(rawNamespaces));
        return Promise.resolve();
    }
    /**
     * Sets up a listener for language changes and updates the application language accordingly.
     *
     * This private method subscribes to language change events using the LanguageContextService.
     * When a new language is selected, it calls the changeLanguage method to update the application's language.
     */
    onLanguageChanged() {
        ServiceProvider.get(LanguageContextService).onSelectedLanguageChanged((languageCode) => {
            if (languageCode) {
                this.changeLanguage(languageCode);
            }
        });
    }
    /**
     * Configures the authentication strategy based on the provided security configuration.
     *
     * This private method retrieves the AuthenticationService and sets the authentication strategy
     * according to the given SecurityConfig. It ensures that the application uses the correct
     * authentication mechanism as specified in the security settings.
     *
     * @param securityConfig - The SecurityConfig object containing the security settings to be applied.
     */
    setAuthStrategy(securityConfig) {
        const authenticationStorageService = ServiceProvider.get(AuthenticationStorageService);
        const securityContextService = ServiceProvider.get(SecurityContextService);
        const authorizationService = ServiceProvider.get(AuthorizationService);
        authenticationStorageService.clearAuthToken();
        const authStrategyResolver = service(AuthStrategyResolver);
        const authStrategy = authStrategyResolver.resolveStrategy(securityConfig);
        authStrategy.initialize().then((isLoggedIn) => {
            securityContextService.updateIsLoggedIn(isLoggedIn);
            if (!isLoggedIn) {
                if (authorizationService.hasFreeAccess()) {
                    authorizationService.initializeFreeAccess();
                }
                else if (securityConfig.hasOverrideAuth()) {
                    authorizationService.initializeOverrideAuth();
                }
            }
        });
    }
    /**
     * Creates a SecurityConfig instance, merging default values with any provided overrides.
     *
     * This private method constructs a SecurityConfig object by combining default settings
     * with any specified overrides. It ensures that all necessary properties are set,
     * providing a complete configuration for security-related operations.
     * @param overrides
     * @private
     */
    createSecurityConfig(overrides) {
        const config = Object.assign({ enabled: true, userLoggedIn: false, passwordLoginEnabled: false, openIdEnabled: false, freeAccess: {}, overrideAuth: {} }, overrides);
        return new SecurityConfig(config);
    }
};

export { OntoTestContext as onto_test_context };
